import HomePage from "pages/auth/home";

import ManagerPage from "pages/auth/member/manager";
import UserPage from "pages/auth/member/user";

import RoomStatusPage from "pages/auth/room/status";
import RmOpPage from "pages/auth/room/option";
import RmPage from "pages/auth/room/room";
import ResvPage from "pages/auth/room/resv";
import RmRsvCnlPage from "pages/auth/room/cancelResv";
import RoomHistoryPage from "pages/auth/room/history";
import RoomProductPage from "pages/auth/room/product";
import * as constent from "../constent";

export const route = [
  {
    id: constent.PAGE_ID_HOME,
    title: "menu_home",
    menu: [],
  },
  {
    id: constent.PAGE_ID_MEMBER,
    title: "menu_mem",
    menu: [
      {
        id: constent.PAGE_ID_MEMBER_ADMIN,
        name: "menu_mem_admin",
        permission: "R",
      },
      {
        id: constent.PAGE_ID_MEMBER_MANAGER,
        name: "menu_mem_manager",
        permission: "R",
      },
      {
        id: constent.PAGE_ID_MEMBER_USER,
        name: "menu_mem_user",
        permission: "R",
      },
    ],
  },
  {
    id: constent.PAGE_ID_ROOM,
    title: "menu_room",
    menu: [
      {
        id: constent.PAGE_ID_ROOM_CURRENT,
        name: "memu_room_crr",
        permission: "R",
      },
      {
        id: constent.PAGE_ID_ROOM_RESV,
        name: "memu_room_resv",
      },
      {
        id: constent.PAGE_ID_ROOM_RESV_CANCEL,
        name: "memu_room_cnl",
        permission: "R",
      },
      {
        id: constent.PAGE_ID_ROOM_PRODUCT,
        name: "memu_room_prd",
        permission: "R",
      },
      {
        id: constent.PAGE_ID_ROOM_HISTORY,
        name: "memu_room_hst",
        permission: "R",
      },
      {
        id: constent.PAGE_ID_ROOM_ROOM,
        name: "memu_room",
        permission: "R",
      },
      {
        id: constent.PAGE_ID_ROOM_OPTION,
        name: "memu_room_op",
        permission: "R",
      },
    ],
  },
];

export const pageList = [
  {
    id: constent.PAGE_ID_HOME,
    title: "menu_home",
    component: HomePage,
  },

  {
    id: constent.PAGE_ID_MEMBER_ADMIN,
    name: "menu_mem_admin",
    // component: AdminPage,
  },
  {
    id: constent.PAGE_ID_MEMBER_MANAGER,
    name: "menu_mem_manager",
    component: ManagerPage,
  },
  {
    id: constent.PAGE_ID_MEMBER_USER,
    name: "menu_mem_user",
    component: UserPage,
  },

  {
    id: constent.PAGE_ID_ROOM_CURRENT,
    name: "memu_room_crr",
    component: RoomStatusPage,
  },
  {
    id: constent.PAGE_ID_ROOM_RESV,
    name: "memu_room_resv",
    component: ResvPage,
  },
  {
    id: constent.PAGE_ID_ROOM_RESV_CANCEL,
    name: "memu_room_cnl",
    component: RmRsvCnlPage,
  },
  {
    id: constent.PAGE_ID_ROOM_PRODUCT,
    name: "memu_room_prd",
    component: RoomProductPage,
  },
  {
    id: constent.PAGE_ID_ROOM_HISTORY,
    name: "memu_room_hst",
    component: RoomHistoryPage,
  },
  {
    id: constent.PAGE_ID_ROOM_ROOM,
    name: "memu_room",
    component: RmPage,
  },
  {
    id: constent.PAGE_ID_ROOM_OPTION,
    name: "memu_room_op",
    component: RmOpPage,
  },
];
